class ABTestManager {
    constructor() {
        this.initialized = false;
        this.experiments = [];
    }

    init() {
        if (this.initialized) return;
        this.initialized = true;

        if (window.posthog) {
            posthog.onFeatureFlags(() => {
                this.applyExperiments();
                if (window.removeAntiFlicker) {
                    window.removeAntiFlicker();
                }
            });
        } else {
            console.warn('PostHog not found');
            if (window.removeAntiFlicker) { 
                window.removeAntiFlicker();
            }
        }
    }

    registerExperiment(experimentName, callback) {
        this.experiments.push({ name: experimentName, callback: callback });
    }

    applyExperiments() {
        this.experiments.forEach(exp => {
            const variant = posthog.getFeatureFlag(exp.name);
            if (variant) {
                console.log(`Applying experiment: ${exp.name}, Variant: ${variant}`);
                exp.callback(variant);
            }
        });
    }
}

window.abTestManager = new ABTestManager();
// Auto-init if PostHog is ready, otherwise wait
if (window.posthog) {
    window.abTestManager.init();
} else {
    // Poll or wait for load
    // The posthog-init snippet handles the load callback, but we can also poll
    var checkInterval = setInterval(function () {
        if (window.posthog) {
            clearInterval(checkInterval);
            window.abTestManager.init();
        }
    }, 100);

    // Safety timeout to remove anti-flicker
    setTimeout(function () {
        if (window.removeAntiFlicker) window.removeAntiFlicker();
    }, window.AB_TEST_CONFIG ? window.AB_TEST_CONFIG.timeout : 4000);
}
